export const CHANGELOG = [
  {
    version: "2.8.0",
    date: "Mar 21, 2026",
    changes: [
      { type: "feature", text: "Blaze board skin is now free for all users" },
      { type: "improvement", text: "Changelog and Purchases menu options hidden during active game pause" },
      { type: "improvement", text: "Challenge name moved above the scroll area in the pause menu" },
      { type: "improvement", text: "Default board removed from store — Blaze is now the baseline" },
      { type: "improvement", text: "Board skin cards resized for better visibility in the store" },
      { type: "improvement", text: "Board skin feature list updated to highlight single and multi line clear animations and sounds" },
    ],
  },
  {
    version: "2.7.0",
    date: "Mar 10, 2026",
    changes: [
      { type: "feature", text: "48-hour free trial for new accounts (access Frost, Spectrum themes and boards)" },
      { type: "feature", text: "5-bag randomizer for fairer piece distribution in single player and local multiplayer" },
      { type: "feature", text: "Sitemap and robots.txt for search engine optimization" },
      { type: "feature", text: "Social sharing meta tags for link previews" },
      { type: "feature", text: "Changelog page" },
      { type: "feature", text: "Purchases display in profile for logged-in users" },
      { type: "feature", text: "Mobile warning for unsupported screen sizes" },
      { type: "improvement", text: "Arrow Up key binding for hard drop" },
      { type: "improvement", text: "Rotation sound effects with per-board configuration" },
      { type: "improvement", text: "Spectrum added as a trial skin" },
      { type: "improvement", text: "Store and online multiplayer hidden for non-logged-in users" },
      { type: "improvement", text: "Admin routes disabled in production" },
      { type: "improvement", text: "Updated favicon" },
      { type: "improvement", text: "Menu options scrollable with scroll indicators when content overflows" },
      { type: "fix", text: "Custom key bindings now used in online multiplayer (no longer hardcoded)" },
      { type: "fix", text: "Keyboard throttling added to single player and split screen" },
      { type: "fix", text: "Life saver now triggers line clear sound and finisher effects" },
      { type: "fix", text: "Robots.txt pointed to correct www domain" },
      { type: "fix", text: "Fixed piece rotation breaking near column 9" },
    ],
  },
  {
    version: "2.6.0",
    date: "Feb 2026",
    changes: [
      { type: "feature", text: "Default 3D board available for all users" },
      { type: "feature", text: "Spectrum new block designs with unique visuals" },
      { type: "feature", text: "Life saver feature in online multiplayer" },
      { type: "feature", text: "Enter key shortcut to join rooms" },
      { type: "feature", text: "New background music track" },
      { type: "feature", text: "Sound effects for default board" },
      { type: "improvement", text: "Blaze and Spectrum board visuals updated" },
      { type: "improvement", text: "Store redesigned with cloud-hosted images and thumbnail previews" },
      { type: "improvement", text: "Skin preview modal with keyboard and gamepad navigation" },
      { type: "improvement", text: "Mobile responsive store and modals" },
      { type: "improvement", text: "Online multiplayer accessible without authentication" },
      { type: "improvement", text: "Background music plays only in menu" },
      { type: "improvement", text: "Board size scales with cell size" },
      { type: "improvement", text: "Score animations improved on 3D boards" },
      { type: "improvement", text: "Socket disconnects properly on page leave" },
      { type: "fix", text: "1-row life saver now triggers finisher animation" },
      { type: "fix", text: "Keyboard and gamepad navigation restored after preview modal closes" },
    ],
  },
  {
    version: "2.5.0",
    date: "Jan 2026",
    changes: [
      { type: "feature", text: "Board skins as purchasable items: Blaze, Frost, and Spectrum boards" },
      { type: "feature", text: "Each board skin has unique sound effects" },
      { type: "feature", text: "Skin preview modals in store with live 3D demo" },
      { type: "feature", text: "YouTube video links for skin previews" },
      { type: "feature", text: "Score animation on 3D boards" },
      { type: "feature", text: "Dynamic board border colors based on active skin" },
      { type: "feature", text: "Prime app skin added" },
      { type: "improvement", text: "Inferno finisher effect improved" },
      { type: "improvement", text: "Store updated for board skin purchases" },
    ],
  },
  {
    version: "2.4.0",
    date: "Dec 2025",
    changes: [
      { type: "feature", text: "3D rendered game boards replacing flat 2D boards" },
      { type: "feature", text: "Board skins: Blaze (fire effects), Frost (ice effects), and Prime (metallic)" },
      { type: "feature", text: "3D visual effects: block particles, hard drop trails, line clear explosions, finisher animations" },
      { type: "feature", text: "Contact info and future features section in guide" },
      { type: "improvement", text: "Performance optimized for smooth 3D rendering" },
    ],
  },
  {
    version: "2.3.0",
    date: "Nov 2025",
    changes: [
      { type: "feature", text: "Toast notifications for connection and disconnection events" },
      { type: "feature", text: "Default touch control values for new users" },
      { type: "improvement", text: "Store pricing, links, and checkout flow updated" },
      { type: "improvement", text: "Guide updated with data saving info" },
      { type: "improvement", text: "Login and purchase modals themed to match selected theme" },
      { type: "improvement", text: "Opponent state synced during animations" },
      { type: "improvement", text: "Room state synchronization improved" },
      { type: "improvement", text: "Speed multipliers rebalanced" },
      { type: "improvement", text: "Removed backspace as back key" },
      { type: "improvement", text: "Sign-out loading state" },
      { type: "improvement", text: "Single player auto-focused by default" },
      { type: "improvement", text: "Player name max length increased" },
      { type: "improvement", text: "Game over sound changed" },
      { type: "improvement", text: "Font optimization" },
      { type: "fix", text: "Rate limiting switched to IP-based for room creation and joining" },
      { type: "fix", text: "Auto-reconnection disabled to prevent ghost connections" },
      { type: "fix", text: "Disconnected player game-over handling" },
      { type: "fix", text: "Auth URL parameter cleanup" },
      { type: "fix", text: "Theme loading on initial page load" },
      { type: "fix", text: "Virtual keyboard state when returning from lobby" },
    ],
  },
  {
    version: "2.2.0",
    date: "Oct 2025",
    changes: [
      { type: "feature", text: "Full gamepad and controller navigation across all menus, lobby, modals, and results" },
      { type: "feature", text: "Virtual keyboard for entering player names and room codes with gamepad" },
      { type: "feature", text: "Profile modal with avatar" },
      { type: "feature", text: "Keyboard navigation with circular wrapping" },
      { type: "feature", text: "Auto-switching between mouse, keyboard, and gamepad input modes" },
      { type: "feature", text: "Input validation for all multiplayer events" },
      { type: "feature", text: "Rate limiting for room creation, joining, and in-game events" },
      { type: "feature", text: "Room cleanup and server health check" },
      { type: "feature", text: "Keyboard input throttling during gameplay" },
      { type: "feature", text: "Loading states for ready-up, start game, and return to lobby" },
      { type: "feature", text: "Buy Me a Coffee support button" },
      { type: "improvement", text: "Escape key support for closing modals" },
      { type: "improvement", text: "Button hover effects and focus styles across lobby and modals" },
      { type: "improvement", text: "Smoother laser beam and life saver animations" },
      { type: "improvement", text: "Game results navigation with gamepad" },
      { type: "improvement", text: "Virtual keyboard themed to match selected theme" },
      { type: "improvement", text: "Disabled states for settings during loading" },
      { type: "improvement", text: "Error screens themed" },
      { type: "fix", text: "FPS display capped at 60" },
      { type: "fix", text: "Network timeout errors" },
      { type: "fix", text: "Enter-name flow" },
      { type: "fix", text: "Max players validation" },
      { type: "fix", text: "Cookie handling for authentication" },
    ],
  },
  {
    version: "2.1.0",
    date: "Sep 2025",
    changes: [
      { type: "feature", text: "Google Sign-In with OAuth" },
      { type: "feature", text: "In-app store for browsing and purchasing themes" },
      { type: "feature", text: "Payment integration for theme purchases and refund handling" },
      { type: "feature", text: "User accounts with purchase history and preferences" },
      { type: "feature", text: "Opponent name display during online games" },
      { type: "feature", text: "Line clear multiplier display for all players" },
      { type: "feature", text: "Theme-based navigation bar styling" },
      { type: "improvement", text: "Game modes rebalanced: adjusted time limits and speed multipliers" },
      { type: "improvement", text: "Server restructured for better organization" },
      { type: "improvement", text: "Guide fully rewritten with game modes, controls, scoring, and tips" },
      { type: "improvement", text: "Player name validation with error messages" },
      { type: "fix", text: "Score multipliers rebalanced for online play" },
      { type: "fix", text: "Session management and sign-in reliability" },
    ],
  },
  {
    version: "2.0.0",
    date: "Aug 2025",
    changes: [
      { type: "feature", text: "Online multiplayer with up to 4 players" },
      { type: "feature", text: "Game modes: Classic, Time Attack, and Speed Battle" },
      { type: "feature", text: "6-character room codes for private matches" },
      { type: "feature", text: "Room lobby with ready-up system and return-to-lobby" },
      { type: "feature", text: "Real-time opponent boards visible during gameplay" },
      { type: "feature", text: "Rankings screen with confetti for winners" },
      { type: "feature", text: "Laser beam line-clear animation" },
      { type: "feature", text: "Ghost piece preview showing where piece will land" },
      { type: "feature", text: "Hard drop in online multiplayer" },
      { type: "feature", text: "Life saver feature with animation for opponents" },
      { type: "feature", text: "Confirmation modals for leaving and quitting" },
      { type: "feature", text: "Theme-based boards and background for each player" },
      { type: "feature", text: "Game timer UI" },
      { type: "feature", text: "Winning and game over sound effects" },
      { type: "fix", text: "Winner calculation for edge cases (disconnects, quits, ties)" },
      { type: "fix", text: "Eliminated intermediate loading screens in rankings" },
    ],
  },
  {
    version: "1.4.0",
    date: "May 2024",
    changes: [
      { type: "feature", text: "Player statistics page with donut progress charts and game history" },
      { type: "feature", text: "Sound when rotation is blocked by wall or piece" },
      { type: "feature", text: "Favicon added" },
    ],
  },
  {
    version: "1.3.0",
    date: "Apr 2024",
    changes: [
      { type: "feature", text: "Challenge system with progression tracking" },
      { type: "feature", text: "In-game stats display: score, lines, and level" },
      { type: "feature", text: "Background music with volume controls" },
      { type: "feature", text: "Hard drop with visual effects" },
      { type: "feature", text: "Game over overlay" },
      { type: "feature", text: "Loading screen" },
      { type: "feature", text: "Mouse navigation support across all menus" },
      { type: "feature", text: "Analytics integration" },
      { type: "improvement", text: "Single player and split-screen made fully responsive" },
      { type: "improvement", text: "Control icons added to settings" },
      { type: "improvement", text: "Guide page rewritten with detailed sections" },
      { type: "improvement", text: "Compressed background music for faster loading" },
      { type: "fix", text: "Game loop stability at 60fps" },
      { type: "fix", text: "Gamepad disconnection handling" },
    ],
  },
  {
    version: "1.2.0",
    date: "Jan 2024",
    changes: [
      { type: "feature", text: "Touch controls for mobile play" },
      { type: "feature", text: "Click and navigation sound effects on all screens" },
      { type: "feature", text: "60fps locked frame rate for smooth gameplay" },
      { type: "improvement", text: "Major styling overhaul across all pages" },
      { type: "improvement", text: "Responsive layout for game, menu, and guide pages" },
    ],
  },
  {
    version: "1.1.1",
    date: "Dec 2023",
    changes: [
      { type: "feature", text: "Score animation popups on line clears" },
      { type: "feature", text: "Start countdown timer before game begins" },
      { type: "feature", text: "Laser shooting and card flying SVG animations" },
      { type: "feature", text: "New sound effects: ball tap, electrical buzz, whoosh, and voice clips" },
      { type: "improvement", text: "Game mode selection and result screen styling" },
    ],
  },
  {
    version: "1.1.0",
    date: "Nov 2023",
    changes: [
      { type: "feature", text: "Theme system with 5 color themes" },
      { type: "feature", text: "Guide page with full game instructions" },
      { type: "feature", text: "Split-screen local multiplayer for 2 players" },
      { type: "feature", text: "Result screen with player scores" },
      { type: "improvement", text: "Reusable component library for UI cards and options" },
    ],
  },
  {
    version: "1.0.0",
    date: "Sep 2023",
    changes: [
      { type: "feature", text: "Core Tetris game engine: board, piece spawning, collision detection, line clearing, scoring" },
      { type: "feature", text: "Single player mode" },
      { type: "feature", text: "Home page and main menu" },
      { type: "feature", text: "Keyboard and gamepad controls" },
      { type: "feature", text: "Sound effects: line clear, game over, navigation, and more" },
    ],
  },
];
